import { USER_TYPES } from "../../../utils/constants";
import { SelectFieldInput } from "../../../components/index"
import { FormikProps } from "formik";
import { SignInFormProps } from "../types/sign-up-form-types";

const UserTypeInput = ({formik} : {formik: FormikProps<SignInFormProps>}) => {
  const inputProps = {
    value: formik.values.userType,
    onChange: formik.handleChange,
    error: formik.touched.userType && Boolean(formik.errors.userType),
    helperText: formik.touched.userType && formik.errors.userType,
  }
  return (
    <SelectFieldInput label="Select your role" name="userType" options={USER_TYPES} inputProps={inputProps} isRequired />
  )
}

export default UserTypeInput;